import { type TBTStatusBadgeDisplayTypes } from "@btnet/core-components";

import { type StatusTypes } from "commonComponents/utilities/Status/StatusDisplay";

/**
 * Maps the legacy `StatusTypes` union (used by StatusDisplay / StatusTagDisplay) to a
 * BTStatusBadge `displayType`. Shared by the surfaces migrating from the old span/BdsBadge
 * status pills to BTStatusBadge so the status→color mapping stays consistent across them.
 */
export function statusTypeToDisplayType(statusType: StatusTypes): TBTStatusBadgeDisplayTypes {
    switch (statusType) {
        case "success":
            return "success";
        case "danger":
        case "emergency":
            return "danger";
        case "pending":
            return "warning";
        case "info":
            return "info";
        default:
            return "default";
    }
}
